import { useCallback, useState } from "react";

export function useSelection<K extends string>(
  options: K[],
  initial?: K
): { value: K; is(value: K): boolean; set(value: K): void; options: K[] } {
  const [value, setValue] = useState(initial || options[0]);
  const set = useCallback((v: K) => setValue(v), []);
  const is = useCallback((v: K) => value === v, [value]);
  return { value, set, is, options };
}
